import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useSnackbar } from 'notistack'
import utilServices from 'app/services/util-services'
import {
    selectItemById,
    getInfobarById,
    updateInfobar,
    updateInfoBarImage,
} from 'app/redux/store/features/infobars'
import UpdateInfoBarForm from './UpdateInfoBarForm'

function toStartOfDay(value) {
    if (value == null) return value
    const d = value instanceof Date ? new Date(value.getTime()) : new Date(value)
    if (isNaN(d.getTime())) return value
    d.setHours(0, 0, 0, 0)
    return d
}

const UpdateInfoBar = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { enqueueSnackbar } = useSnackbar()
    const [apiCallInProgress, setApiCallInProgress] = useState(false)
    const { state } = useLocation()
    const { id } = state
    const { infobars, loading, error } = useSelector((state) => state.infobars)
    const infobar = selectItemById(infobars, id)

    useEffect(() => {
        if (utilServices.isNullOrUndefined(infobar.id)) dispatch(getInfobarById({ id: id }))
    }, [])

    useEffect(() => {
        if (!apiCallInProgress || loading) return

        if (error) {
            handleError(error)
            setApiCallInProgress(false)
            return
        }

        enqueueSnackbar('Info Bar updated successfully', {
            variant: 'success',
            anchorOrigin: { vertical: 'top', horizontal: 'right' },
        })
        navigate('/settings/configuration/info-bar')
        setApiCallInProgress(false)
    }, [loading])

    function handleError(error) {
        if (error?.status === 401) {
            navigate('/profile/signout')
        } else if (error?.detail) {
            enqueueSnackbar(error.detail, {
                variant: 'error',
                anchorOrigin: { vertical: 'top', horizontal: 'right' },
            })
        } else {
            enqueueSnackbar(error?.message || String(error), {
                variant: 'error',
                anchorOrigin: { vertical: 'top', horizontal: 'right' },
            })
        }
    }

    const onUpdateInfoBar = () => {
        setApiCallInProgress(true)
        dispatch(
            updateInfobar({
                ...infobar,
                dateStart: toStartOfDay(infobar.dateStart) ?? infobar.dateStart,
                dateEnd: infobar.dateEnd,
            })
        )
    }

    const onReplaceImage = (infobarData, file) => {
        if (!file) return
        const form = new FormData()
        form.append('Id', infobarData.id)
        form.append('Image', file)
        setApiCallInProgress(true)
        dispatch(updateInfoBarImage(infobarData.id, form, { 'Content-Type': 'multipart/form-data' }))
    }

    return (
        <React.Fragment>
            <UpdateInfoBarForm
                infoBarData={infobar}
                updateInfoBar={onUpdateInfoBar}
                onReplaceImage={onReplaceImage}
            />
        </React.Fragment>
    )
}

export default UpdateInfoBar
